module.exports = __webpack_public_path__ + "static/ring_of_mind_shielding-30660a30ca6151e3e97f60f0f3f0353f.jpeg";